import React from "react";
import { injectIntl } from "react-intl";
import ForgotPasswordForm from "../forgotPasswordForm";
import FormLayout from "components/FormLayout";

class ForgotPasswordLayoutComponent extends React.Component {
  render() {
    const { intl } = this.props;

    return (
      <FormLayout label={intl.messages["loginScene.login.logoForgotPwdLabel"]}>
        <ForgotPasswordForm />
      </FormLayout>
    );
  }
}

export default injectIntl(ForgotPasswordLayoutComponent);
